import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_COMBO_PROMOTER_CONTRIBUTION_IMPACT_VALUES = createFcmDetails(
	'combo_promoter_contribution_impact_values',
	{
		owner: 'TBD',
		context: 'PSF promote or share page',
		description: 'Provides values to generate the "Join the community" footer. If unset, the footer will not be shown.',
		import: false,
		template: {
			custom_promoter_count: 25,
			custom_contribution_amount: 25,
			custom_additional_signatures: 1000,
		},
	},
);
